import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Container from "@material-ui/core/Container";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import { AppContext, signOut } from "./App";

const useStyles = makeStyles(theme => ({
  toolbar: {
    justifyContent: "flex-end"
  },
  titulo: {
    flex: 1
  },
  container: {
    minHeight: "100vh",
    paddingTop: "10vh",
    [theme.breakpoints.up("sm")]: {
      paddingTop: "15vh"
    }
  },
  subtitulo: {
    marginBottom: theme.spacing(3)
  },
  card: {
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  }
}));

const SelectorCliente = () => {
  const classes = useStyles();

  const { usuario, clientes, onClienteChange } = useContext(AppContext);

  return (
    <div>
      <AppBar position="fixed" color="transparent" elevation={0}>
        <Toolbar className={classes.toolbar}>
          <Avatar src={`${process.env.PUBLIC_URL}/assets/images/logo_cf.png`} alt="Carrito Fácil" />

          <Typography className={classes.titulo} variant="h6">
            Carrito Fácil
          </Typography>

          <Hidden xsDown>
            <Typography color="textSecondary">
              {`${usuario.primer_nombre_usuario} ${usuario.apellido_paterno_usuario}`}
            </Typography>
          </Hidden>

          <IconButton onClick={signOut}>
            <PowerSettingsNewIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container className={classes.container} maxWidth="xs">
        <Typography className={classes.subtitulo} variant="h5">
          Seleccione una tienda
        </Typography>

        {clientes.map((cliente, index) => (
          <Card key={`cliente-${index}`} className={classes.card}>
            <CardActionArea onClick={() => onClienteChange(cliente)}>
              <CardContent>
                <Typography variant="h6">{cliente.nombre_cliente}</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Container>
    </div>
  );
};

export default SelectorCliente;
